module.exports = __webpack_public_path__ + "img/airpa_21.f98ce7ea.svg";